<template>
  <div class="main-layout predicted-item-page" v-loading="handleLoading">
    <el-card shadow="never" class="box-inner box-bg">
      <c-title slot="header" title="绿色通道"></c-title>
      <div class="pb110">
        <div class="div-scroll">
          <el-row class="form-container">
            <el-form
              size="small"
              :model="applyInfo"
              ref="cForm"
              :rules="formRules"
              label-width="120px"
              label-position="left"
              :disabled="disabled"
            >
              <el-form-item label="是否生源地贷款">
                <el-switch
                  v-model="isApply"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </el-form-item>
              <div class="tips-container">
                <div class="tips">
                  <div class="title">
                    <i class="el-icon-info"></i><span>温馨提示</span>
                  </div>
                  <p>1、若您未办理生源地信用助学贷款，则选择"否"后直接提交。</p>
                  <p>
                    2、如果您办理了国家开发银行生源地信用助学贷款，需在网报系统“绿色通道”栏提交《国家开发银行生源地信用助学贷款受理证明》上的回执校验码与实际贷款金额，贷款金额不足以支付学费和住宿费的学生，请于9月5日至9月8日期间登陆缴费系统缴纳剩余费用。
                  </p>
                  <p>
                    3、如果您为非国家开发银行助学贷款或未办理助学贷款的家庭经济困难学生，请点击网报系统“绿色通道”
                    栏中“否” 选项，并于报到当天现场办理“绿色通道” 入学手续。
                  </p>
                </div>
              </div>
              <div v-if="isApply">
                <!-- <el-form-item label="缓缴内容" prop="content">
                  <el-checkbox-group v-model="applyInfo.content">
                    <el-checkbox label="isTuition" name="1">学费</el-checkbox>
                    <el-checkbox label="isDormitory" name="2"
                      >住宿费</el-checkbox
                    >
                    <el-checkbox label="isOther" name="3"
                      >其他费用（材料费、体检费、军训服费用等）</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="缓缴原因" prop="reason">
                  <el-input
                    type="textarea"
                    v-model="applyInfo.reason"
                  ></el-input>
                </el-form-item>
                <el-form-item label="最晚缴费时间" prop="endTime">
                  <el-date-picker
                    type="datetime"
                    placeholder="请选择"
                    v-model="applyInfo.endTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="是否生源地贷款" prop="isLoan">
                  <el-radio-group
                    v-model="applyInfo.isLoan"
                    @change="loanChange"
                  >
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item> -->
                <el-form-item
                  label="贷款金额"
                  prop="loanAmount"
                  v-if="isApply"
                  label-width="150px"
                >
                  <el-input v-model="applyInfo.loanAmount"></el-input>
                </el-form-item>
                <el-form-item
                  label="回执校验码"
                  label-width="150px"
                  prop="receiptCode"
                  v-if="isApply"
                >
                  <el-input v-model="applyInfo.receiptCode"></el-input>
                </el-form-item>
                <div class="tips-container">
                  <!-- <div class="template-download">
                    <a :href="link">点击下载申请表模板</a>
                  </div> -->
                  <div class="img-upload">
                    <div class="evidence-upload upload-item">
                      <div class="title">
                        <span class="red">*</span>
                        贷款材料图片上传：
                      </div>
                      <el-upload
                        action="/account/sys/static/upload"
                        list-type="picture-card"
                        accept="image/jpeg,image/jpg,image/png,image/bmp,image/gif"
                        :file-list="fileList"
                        :headers="{ token }"
                        :on-success="handlePictureSuccess"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handlePictureRemove"
                        :on-error="handleError"
                        :http-request="customUpload"
                      >
                        <i class="el-icon-plus" slot="default"></i>
                      </el-upload>
                    </div>
                  </div>
                </div>
              </div>
              <el-col :span="24" style="text-align: center; padding-top: 20px">
                <el-form-item label-width="0">
                  <slot name="other">
                    <el-button
                      type="primary"
                      @click="submit"
                      size="medium"
                      :disabled="isSubmit || disabled"
                      >提交</el-button
                    >
                  </slot>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
      </div>
    </el-card>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import MHandle from "@/mixins/MHandle.js";
import { validateMoney } from "@/libs/elementChecker";
import { guid } from "@/libs/tools.js";
import mUpload from "@/mixins/MUpload.js";
import { mapState } from "vuex";
let mHandle = MHandle({
  handleGetPathNoparam: "/welcome-forecast/green/apply/myInfo",
  handleInsertPath: "/welcome-forecast/green/apply/save",
  handleUpdatePath: "/welcome-forecast/green/apply/update",
  handleDownLoadPath: "",
  handleData: {
    content: [],
    reason: "",
    endTime: "",
    isLoan: 0,
    receiptCode: "",
  },
});
export default {
  name: "",
  mixins: [mHandle, mUpload],
  data() {
    return {
      formRules: {
        loanAmount: [
          {
            required: true,
            validator: validateMoney,
            trigger: "blur",
          },
        ],
        receiptCode: [
          {
            required: true,
            message: "请输入生源地贷款回执码",
            trigger: "blur",
          },
        ],
      },
      studentId: "",
      token: "",
      applyInfo: {
        loanAmount: "", // 贷款金额
        receiptCode: "", // 贷款回执码
      },
      link: "http://yx.ezu.cn/static/welcome/生源地贷款学生学费缓交申请表.xls",
      formFileList: [],
      fileList: [],
      status: "", // 该事项状态
      dialogVisible: false, // 图片预览弹框
      dialogImageUrl: "", // 预览图片地址
      isApply: false, // 是否申请了生源地贷款
      contentType: ["isTuition", "isDormitory", "isOther"],
      isSubmit: false,
      isOrNot: 0,
      pictureUrl: [],
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
    disabled() {
      let status = this.$route.params.status;
      return status == 2 ? true : false;
    },
  },
  created() {
    this.token = localStorage.getItem("token");
    this.studentId = JSON.parse(localStorage.getItem("userInfo")).studentId;
    this.forecastLinkId = this.$route.params.id;
    this.status = this.$route.params.status;
    this.isOrNot =
      this.$route.params.isOrNot == "null"
        ? 0
        : Number(this.$route.params.isOrNot);

    if (this.isOrNot == 0) {
      // 未完成或未申请生源地贷款
      this.isApply = false;
    } else {
      // 申请了生源地贷款，则请求相关详情
      this.isApply = true;
      this.getApplyInfo();
    }
  },
  mounted() {
    // if (this.status == 0) {
    //   this.$confirm("请确认是否生源地贷款", "请确认", {
    //     confirmButtonText: "是",
    //     cancelButtonText: "否",
    //     showClose: false,
    //     type: "warning",
    //     center: true,
    //     closeOnClickModal: false,
    //     closeOnPressEscape: false,
    //   })
    //     .then(() => {
    //       console.log("是");
    //       this.isApply = true;
    //       this.$message.warning("请按要求填写表单，提交相关资料！");
    //     })
    //     .catch(() => {
    //       console.log("否");
    //       this.isApply = false;
    //       this.confirmNoApply();
    //     });
    // }
  },
  methods: {
    // 获取绿色通道详情
    getApplyInfo() {
      this.handleLoading = true;
      this.$http
        .get("/welcome-forecast/green/apply/myInfo")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            if (res.data) {
              this.applyInfo = res.data;
              // 回显图片
              if (res.data.pictureUrl && res.data.pictureUrl.length) {
                res.data.pictureUrl.forEach((item) =>
                  this.fileList.push({ url: item, name: item })
                );
                this.pictureUrl = [...this.fileList];
              }
            }
          } else {
            this.$message.error(`${res.msg}`);
          }
          this.handleLoading = false;
        })
        .catch((err) => {
          this.handleLoading = false;
        });
    },
    loanChange(value) {
      // console.log(value)
      // 当不贷款时清空回执码
      if (value == 0) {
        this.applyInfo.receiptCode = "";
      }
    },
    submit() {
      if (this.isApply) {
        this.$refs.cForm.validate((valid) => {
          if (valid) {
            this.apply();
          } else {
            return false;
          }
        });
      } else {
        // 不申请
        this.noApply();
      }
    },
    handleFormSuccess(res, file, fileList) {
      // console.log(file);
      if (res.code == this.SUCCESS_CODE) {
        file.url = res.data.url;
        this.formFileList = fileList;
      }
    },
    handlePictureSuccess(res, file, fileList) {
      // console.log(this.fileList);
      if (res.code == this.SUCCESS_CODE) {
        file.url = res.data.url;
        this.fileList = fileList;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleFormRemove(file, fileList) {
      // console.log(fileList);
      this.formFileList = fileList;
    },
    handlePictureRemove(file, fileList) {
      this.fileList = fileList;
      let index = this.pictureUrl.findIndex((item) => item.name == file.name);
      this.pictureUrl.splice(index, 1);
    },
    // 申请表上传多张时提醒
    handleExceed(file, fileList) {
      this.$message.warning("只能上传一张图片，请先删除后上传！");
    },
    handleError(err) {
      this.$message.error("上传失败，" + err);
    },
    apply() {
      // let formUrl = this.formFileList.length ? this.formFileList[0].url : "";
      let pictureUrl = this.pictureUrl.length
        ? this.pictureUrl.map((item) => item.url)
        : [];
      if (pictureUrl.length) {
        this.$confirm("请确认无误后提交，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            console.log(this.applyInfo);
            this.applyInfo.forecastLinkId = this.forecastLinkId;
            // this.applyInfo.formUrl = formUrl;
            this.applyInfo.pictureUrl = pictureUrl;
            this.applyInfo.studentId = this.studentId;
            // this.applyInfo.isTuition =
            //   this.applyInfo.content.indexOf("isTuition") > -1 ? 1 : 0;
            // this.applyInfo.isDormitory =
            //   this.applyInfo.content.indexOf("isDormitory") > -1 ? 1 : 0;
            // this.applyInfo.isOther =
            //   this.applyInfo.content.indexOf("isOther") > -1 ? 1 : 0;
            // 判断是否是驳回修改
            // delete this.applyInfo.content;
            if (this.applyInfo.id) {
              this.updateApply(this.applyInfo);
            } else {
              this.saveApply(this.applyInfo);
            }
          })
          .catch(() => {});
      } else {
        this.$alert("请上传《生源地贷款合同》或受理证明等相关资料", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
      }
    },
    saveApply(params) {
      this.isSubmit = true;
      this.handleLoading = true;
      this.$http
        .post("/welcome-forecast/green/apply/save", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success("提交成功");
            // this.$router.go(-1);
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error("提交失败");
          }
          this.isSubmit = false;
          this.handleLoading = false;
        })
        .catch((err) => {
          this.isSubmit = false;
          this.handleLoading = false;
          this.$message.error("提交失败", err);
        });
    },
    // 更新申请
    updateApply(params) {
      this.isSubmit = true;
      this.handleLoading = true;
      this.$http
        .post("/welcome-forecast/green/apply/update", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success("提交成功");
            // this.$router.go(-1);
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error("提交失败");
          }
          this.isSubmit = false;
          this.handleLoading = false;
        })
        .catch((err) => {
          this.isSubmit = false;
          this.handleLoading = false;
          this.$message.error("提交失败", err);
        });
    },
    noApply() {
      this.$confirm("请确认无误后提交，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.confirmNoApply();
        })
        .catch(() => {});
    },
    // 确认无生源地贷款
    confirmNoApply() {
      this.isSubmit = true;
      this.handleLoading = true;
      let params = {
        forecastLinkId: this.forecastLinkId,
        studentId: this.studentId,
      };
      this.$http
        .post("/welcome-forecast/green/apply/noApply", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success("提交成功");
            // this.$router.go(-1);
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error("提交失败");
          }
          this.isSubmit = false;
          this.handleLoading = false;
        })
        .catch((err) => {
          this.isSubmit = false;
          this.handleLoading = false;
          this.$message.error("提交失败", err);
        });
    },
    // 自定义上传方法
    customUpload(e) {
      // console.log(e);
      let self = this;
      var file = e.file;
      var fileName = guid();
      self.obsUpload(file, fileName, this.afterObsUpload);
    },
    afterObsUpload(obsUrl, file) {
      this.pictureUrl.push({ url: obsUrl, name: file.name });
    },
  },
};
</script>
